import React from "react";

interface PriceCommentIconProps {
  color?: string;
}

export const PriceCommentIcon = ({ color = "#94A3B8" }: PriceCommentIconProps) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.16634 1.83301H1.83301V7.33301H3.66634V9.16634L5.49967 7.33301H9.16634V1.83301Z"
      stroke={color}
      strokeWidth="1.1"
      strokeLinejoin="round"
    />
  </svg>
);
